import * as React from 'react';
export const DisabilitiesContext = React.createContext(null);
const DisabilitiesContextProvider = DisabilitiesContext.Provider;
export default DisabilitiesContextProvider;
